import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft, ChevronDown } from 'lucide-react';
import heroBg from '@/assets/hero-bg.jpg';
import logo from '@/assets/logo.png';

export function Hero() {
  const scrollToContent = () => {
    window.scrollTo({
      top: window.innerHeight * 0.85,
      behavior: 'smooth',
    });
  };

  return (
    <section className="relative min-h-[85vh] flex items-center overflow-hidden">
      {/* Background - using img for LCP optimization */}
      <div className="absolute inset-0">
        <img
          src={heroBg}
          alt=""
          fetchPriority="high"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-l from-foreground/90 via-foreground/70 to-foreground/40" />
      </div>

      {/* Floating Particles Effect */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 right-1/4 w-2 h-2 bg-accent/30 rounded-full animate-float" style={{ animationDelay: '0s' }} />
        <div className="absolute top-1/3 left-1/3 w-3 h-3 bg-primary/20 rounded-full animate-float" style={{ animationDelay: '1s' }} />
        <div className="absolute bottom-1/3 right-1/3 w-2 h-2 bg-accent/20 rounded-full animate-float" style={{ animationDelay: '2s' }} />
        <div className="absolute top-1/2 left-1/4 w-4 h-4 bg-primary-foreground/10 rounded-full animate-float" style={{ animationDelay: '0.5s' }} />
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-2xl mx-auto text-center">
          {/* Logo with Float Animation */}
          <img 
            src={logo} 
            alt="Barbor Meals" 
            className="h-20 md:h-24 mx-auto mb-6 animate-fade-in-down transition-all duration-500 hover:scale-110 hover:drop-shadow-[0_0_25px_rgba(255,255,255,0.6)] cursor-pointer"
            style={{ animationDelay: '0.2s' }}
          />
          
          <h1 
            className="text-4xl md:text-6xl lg:text-7xl font-bold text-primary-foreground mb-6 leading-tight animate-blur-in"
            style={{ animationDelay: '0.4s' }}
          >
            תזונה בריאה.
            <br />
            <span className="text-accent bg-gradient-to-r from-accent to-yellow-300 bg-clip-text text-transparent animate-gradient-x bg-[length:200%_auto]">
              טעם מושלם.
            </span>
          </h1>
          
          <p 
            className="text-lg md:text-xl text-primary-foreground/90 mb-8 leading-relaxed animate-fade-in-up"
            style={{ animationDelay: '0.6s' }}
          >
            מנות בריאות ומאוזנות, מוכנות במיוחד עבורך.
            <br />
            עשירות בחלבון, דלות בפחמימות, וטעימות במיוחד.
          </p>

          <div 
            className="flex justify-center animate-scale-in-bounce"
            style={{ animationDelay: '0.8s' }}
          >
            <Link to="/meals">
              <Button 
                size="lg" 
                className="group text-lg px-10 py-7 relative overflow-hidden transition-all duration-300 hover:shadow-[0_0_30px_rgba(var(--primary),0.5)]"
              >
                <span className="relative z-10 flex items-center">
                  לתפריט
                  <ArrowLeft className="mr-2 h-5 w-5 transition-transform group-hover:-translate-x-2" />
                </span>
                {/* Shimmer Effect */}
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" />
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToContent}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-primary-foreground/70 hover:text-primary-foreground transition-colors animate-bounce-soft cursor-pointer"
        aria-label="גלול למטה"
      >
        <ChevronDown className="h-8 w-8" />
      </button>
    </section>
  );
}
